/**
 * Formats a number to a string representation with a specified precision.
 *
 * @param value - The number to format.
 * @returns The formatted number as a string.
 */

export function frontendNumber(value: number): string {
  return Intl.NumberFormat("de-DE", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value)
}
